import { useRef, useState } from "react";
import "./HomePage.css";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import RedirectWithConfirm from "./RedirectWithConfirm";
import rentLeaseImg from "../../assets/images/landingPage/drone_6758591.png";
import progressiveFarmingIcon from "../../assets/images/landingPage/farm_3561394.png";
import farmersCityMartIcon from "../../assets/images/landingPage/shopping-cart_800344.png";
import gaonSeIcon from "../../assets/images/landingPage/livestock-farming_18784792.png";
import droneServicesIcon from "../../assets/images/landingPage/drone_6758591.png";
import hireFarmLabourIcon from "../../assets/images/landingPage/subsistence_17870071.png";
import talkIcon from "../../assets/images/landingPage/talk_10815883.png";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { ChevronRight } from "lucide-react";

// const ICONS = {
//   agriculture: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M12 4V2" />
//       <path d="M12 22v-2" />
//       <path d="M17 9.4a5 5 0 0 0-10 0" />
//       <path d="M20 12h2" />
//       <path d="M2 12h2" />
//       <path d="m14.8 14.8 1.4 1.4" />
//       <path d="m7.8 7.8 1.4 1.4" />
//       <path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z" />
//     </svg>
//   ),
//   photography: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
//       <circle cx="12" cy="13" r="3" />
//     </svg>
//   ),
//   survey: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
//       <path d="m9.5 9 5 5" />
//       <path d="m14.5 9-5 5" />
//     </svg>
//   ),
//   nano: (props) => (
//     <svg
//       {...props}
//       xmlns="http://www.w3.org/2000/svg"
//       width="24"
//       height="24"
//       viewBox="0 0 24 24"
//       fill="none"
//       stroke="currentColor"
//       strokeWidth="2"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     >
//       <path d="M12 12h.01" />
//       <path d="M10 18v-2a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v2" />
//       <path d="M10 22h4" />
//       <path d="M16 10a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2" />
//       <path d="m18 10-1.7-1.7" />
//       <path d="m6 10 1.7-1.7" />
//       <path d="m12 6 1.1-1.1" />
//       <path d="M8.5 2.5 12 6l3.5-3.5" />
//     </svg>
//   ),
// };

const features = [
  // {
  //   title: "Rent / Lease / Sale",
  //   desc: "Lease or sell farmland and machinery on a flexible, time-based basis with secure digital contracts and geo-verification.",
  //   redirect: "/all-product",
  //   img: rentLeaseIcon,
  // },
  {
    title: "Progressive Farming Solutions",
    desc: "Soil testing, smart irrigation, digital farm management, and precision farming with IoT & drones.",
    redirect: "/progressive-farming-solutions",
    img: progressiveFarmingIcon,
  },
  {
    title: "Farmer’s City Mart",
    desc: "Marketplace for agri inputs, machinery, animal feed, and supplements with last-mile delivery.",
    redirect: "/farmer-shop",
    img: farmersCityMartIcon,
  },
  {
    title: "Gaon Se",
    desc: "Direct farmer-to-city supply of produce, dairy, and livestock with cold-chain logistics & real-time pricing.",
    redirect: "/gaon-se",
    img: gaonSeIcon,
  },
  {
    title: "Drone Services",
    desc: "Book drones for spraying, mapping, and monitoring.",
    redirect: "external-drone",
    img: droneServicesIcon,
  },
  {
    title: "Hire Farm Labour",
    desc: "Find skilled labourers for your farm quickly.",
    redirect: "/hire-farm-labour",
    img: hireFarmLabourIcon,
  },
  {
    title: "Consultation",
    desc: "Talk to expert advice.",
    redirect: "/consultation",
    img: talkIcon,
  },
];

const FeatureCard = ({ img, title, desc, onExplore }) => {
  return (
    <div className="feature-card">
      <div className="card-body">
        <div className="card-icon">
          <img src={img} alt={title} />
        </div>
        <h5 className="card-title">{title}</h5>
        <p className="card-text">{desc}</p>
        <div className="card-footer">
          <button className="explore-btn" onClick={onExplore}>
            Explore →
          </button>
        </div>
      </div>
    </div>
  );
};

// const ServicesCard = ({ image, title, description, icon, url }) => {
//   const cardRef = useRef(null);
//   const [cardStyle, setCardStyle] = useState({});
//   const [spotlightStyle, setSpotlightStyle] = useState({});
//   const IconComponent = ICONS[icon];

//   const handleMouseMove = (e) => {
//     if (!cardRef.current) return;
//     const { clientX, clientY } = e;
//     const { left, top, width, height } =
//       cardRef.current.getBoundingClientRect();
//     const x = clientX - left - width / 2;
//     const y = clientY - top - height / 2;

//     const rotateX = (y / height) * -30;
//     const rotateY = (x / width) * 30;

//     setCardStyle({
//       transform: `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`,
//       transition: "transform 0.1s ease-out",
//     });

//     setSpotlightStyle({
//       background: `radial-gradient(circle at ${x + width / 2}px ${
//         y + height / 2
//       }px, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0) 40%)`,
//     });
//   };

//   const handleMouseLeave = () => {
//     setCardStyle({
//       transform:
//         "perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)",
//       transition: "transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)",
//     });
//     setSpotlightStyle({ background: "none" });
//   };

//   return (
//     <a
//       href={url}
//       ref={cardRef}
//       className="ccard group"
//       style={{ transformStyle: "preserve-3d" }}
//       onMouseMove={handleMouseMove}
//       onMouseLeave={handleMouseLeave}
//     >
//       <div className="ccard-visual" style={cardStyle}>
//         <img
//           src={image}
//           alt={title}
//           onError={(e) => {
//             e.target.onerror = null;
//             e.target.src = `https://placehold.co/600x400/1e293b/94a3b8?text=${title.replace(
//               " ",
//               "+"
//             )}`;
//           }}
//           className="ccard-img"
//         />
//         <div className="ccard-gradient"></div>
//       </div>

//       <div className="ccard-spotlight" style={spotlightStyle}></div>
//       <div className="ccard-border"></div>
//       <div className="ccard-content" style={{ transform: "translateZ(50px)" }}>
//         {IconComponent && <IconComponent className="ccard-icon" />}
//         <h2 className="ccard-title">{title}</h2>
//         <p className="ccard-description">{description}</p>
//         <div className="ccard-link" onClick={url}>
//           <span>Learn More</span>
//           <ChevronRight className="ccard-chevron" />
//         </div>
//       </div>
//     </a>
//   );
// };

const RentLease = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [externalUrl, setExternalUrl] = useState(null);

  const handleExplore = (redirect) => {
    console.log("Redirecting to:", redirect);
    if (redirect === "external-drone") {
      setExternalUrl("https://droneplanet.in/aboutdaas");
      setShowModal(true);
    } else {
      navigate(redirect);
    }
  };

  const confirmRedirect = () => {
    setShowModal(false);
    if (externalUrl) {
      window.open(externalUrl, "_blank");
    }
  };

  const cancelRedirect = () => {
    setShowModal(false);
    setExternalUrl(null);
  };

  return (
    <div className="py-5 bg-custom-hero">
      <div className="container text-white service-container">
        <h2 className="text-center fw-bold mb-3">Services for Farmers 🌾</h2>
        <p className="text-center mb-4 sub-heading">
          Choose from our farmer-friendly services. Simple, clear, and ready to
          use.
        </p>
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={16}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1.2 },
            576: { slidesPerView: 2 },
            768: { slidesPerView: 3 },
            920: { slidesPerView: 4 },
            1280: { slidesPerView: 5 },
          }}
        >
          {features.map((item, index) => (
            <SwiperSlide key={index} className="swiper-slide-flex">
              <FeatureCard
                img={item.img}
                title={item.title}
                desc={item.desc}
                onExplore={() => handleExplore(item.redirect)}
              />
              {/* <ServicesCard
                image={item.img}
                title={item.title}
                description={item.desc}
                url={() => handleExplore(item.redirect)}
              /> */}
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom Confirmation Modal */}
        <RedirectWithConfirm
          show={showModal}
          url={externalUrl}
          onCancel={cancelRedirect}
          onConfirm={confirmRedirect}
        />
      </div>
    </div>
  );
};

export default RentLease;